import { Injectable } from "@angular/core";
import { BaseService } from "@app/core/services/base.service";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { ToastService } from "@siu/shared";
import { Observable } from "rxjs";

@Injectable()
export class AutorizacionConsultaService extends BaseService {
  private url: string = `${environment.apiGatewayAddress}/a/v1/AutorizacionAAM/`;
  private urlApiGateway: string = `${environment.apiGatewayAddress}/api/v1/AutorizacionAAM/`;

  constructor(
    private http: HttpClient,
    toast: ToastService
  ) {
    super(toast);
  }

  fetchSolicitudById = (
    idSolicitud: number
  ): Observable<any> => {
    return this.http.get(`${this.url}Buscar-SolicitudPorId?idSolicitud=${idSolicitud}`);
  };

  fetchCronogramaById = (
    idCronograma: number
  ): Observable<any> => {
    return this.http.get(`${this.url}Buscar-Cronograma-PorId?idCronograma=${idCronograma}`);
  };

  fetchCronogramaByIdDocumento = (
    idDocumento: number
  ): Observable<any> => {
    return this.http.get(`${this.url}Buscar-Cronograma-PorIdDocumento?idDocumento=${idDocumento}`);
  };

  fetchSubsanadoByIdDocumento = (
    idDocumento: number
  ): Observable<any> => {
    return this.http.get(`${this.url}Consultar-Subsanado-PorIdDocumento?idDocumento=${idDocumento}`);
  };
}